import { firestoreAction } from 'vuexfire'
import _ from 'lodash'
import { lessonsCollection } from '@/firebase/data'
import {currentUserId} from '@/firebase/firebase'
import { timestamp } from '@/firebase/firebaseHelpers'
import * as DateHelper from '@/helpers/date'

export default {
  state: {
    lessons: [],
    lessonsLoaded: false
  },
  getters: {
      userLessons: (state) => state.lessons,
      lessonsLoaded: (state) => state.lessonsLoaded,
      openLessonsCount: (state) => _.size(_.filter(state.lessons, ['status', 'open'])),
      hasOpenLessons: (state) => _.size(_.filter(state.lessons, ['status', 'open'])) > 0,
      openLessonIndex: (state) => _.get(_.find(state.lessons, ['status', 'open']), 'order'),
    },
  mutations: {
    setDataLoaded (state) {
      state.lessonsLoaded = true
    }
  },
  actions: {
    bindLessons: firestoreAction(context => {
      // context contains all original properties like commit, state, etc
      // and adds `bindFirestoreRef` and `unbindFirestoreRef`
      // we return the promise returned by `bindFirestoreRef` that will
      // resolve once data is ready
      return context.bindFirestoreRef(
        'lessons',
        lessonsCollection.where('uid', '==', currentUserId()),
        { wait: true }
      ).then(() => { context.commit('setDataLoaded') })
    }),
    async ADD_INITIAL_LESSONS_DELAYED () {
      console.log('ADD_INITIAL_LESSONS_DELAYED'
        )
      setTimeout(() => {

        lessonsCollection.add(
          {
            uid: currentUserId(),
            createdAt: timestamp(),
            status: 'open',
            name: 'LetsMeet',
            order: -1
          })

        lessonsCollection.add(
          {
            uid: currentUserId(),
            createdAt: timestamp(),
            status: 'open',
            name: 'RealityCheck',
            order: 0
          })

        lessonsCollection.add({
            uid: currentUserId(),
            createdAt: timestamp(),
            status: 'pending',
            name: 'Responsibility',
            order: 1
          })
      }, 10000)
    },
    async ADD_ALL_LESSONS () {
      console.log('ADD_ALL_LESSONS'
        )

        lessonsCollection.add(
          {
            uid: currentUserId(),
            createdAt: timestamp(),
            status: 'open',
            name: 'LetsMeet',
            order: -1
          })

        lessonsCollection.add(
          {
            uid: currentUserId(),
            createdAt: timestamp(),
            status: 'open',
            name: 'RealityCheck',
            order: 0
          })
        lessonsCollection.add({
            uid: currentUserId(),
            createdAt: timestamp(),
            status: 'open',
            name: 'Responsibility',
            order: 1
          })
          lessonsCollection.add({
            uid: currentUserId(),
            createdAt: timestamp(),
            status: 'open',
            name: 'SomethingToAimAt',
            order: 2
          })

        lessonsCollection.add({
            uid: currentUserId(),
            createdAt: timestamp(),
            status: 'open',
            name: 'TiniestGoal',
            order: 3
          })

        lessonsCollection.add({
            uid: currentUserId(),
            createdAt: timestamp(),
            status: 'open',
            name: 'PurposefulRoutine',
            order: 4
          })

          lessonsCollection.add({
            uid: currentUserId(),
            createdAt: timestamp(),
            status: 'open',
            name: 'IncreaseYourChances',
            order: 5
          })

         lessonsCollection.add({
            uid: currentUserId(),
            createdAt: timestamp(),
            status: 'open',
            name: 'HabitsThatStick',
            order: 6
          })

          lessonsCollection.add({
            uid: currentUserId(),
            createdAt: timestamp(),
            status: 'open',
            name: 'StopComparingToOthers',
            order: 7
          })
    },
    async REMOVE_ALL_LESSONS ({ getters, state }) {
      console.log('REMOVE_ALL_LESSONS')
      console.log(getters.userLessons)
      console.log(state.lessons)

       _.each(
        getters.userLessons,
        (lesson) => lessonsCollection.doc(lesson.id).delete()
      )

    },
    async UPDATE_LESSON (_, { lesson, updateFields }) {
      console.info('UPDATE_LESSON', lesson, updateFields)

      // if (updateFields.hasOwnProperty('deadline') || updateFields.hasOwnProperty('showList')) {
      //   console.log('removin list index')
      //   updateFields.listIndex = null
      // }

      lessonsCollection.doc(lesson.id).update(updateFields)
    },
  }
}
